import {
    WISHLIST_UPDATE_WISHLIST_NAME,
    WISHLIST_ADD_TO_CART,
    WISHLIST_ADD_ALL_TO_CART,
    WISHLIST_GET,
    WISHLIST_GET_ALL,
    WISHLIST_DELETE,
    WISHLIST_DELETE_ITEM,
    REMOVE_ERROR,
} from '../Services/WishList.service';

export const wishList = (state = {}, action) => {
    switch (action.type) {
        case WISHLIST_UPDATE_WISHLIST_NAME:
        case WISHLIST_ADD_TO_CART:
        case WISHLIST_ADD_ALL_TO_CART:
        case WISHLIST_DELETE:
        case WISHLIST_DELETE_ITEM:
            return {
                ...state,
                payload: action.payload,
            };
        case WISHLIST_GET:
            return {
                ...state,
                payload: action.payload,
                list: action.payload.list,
            };
        case WISHLIST_GET_ALL:
            return {
                ...state,
                payload: action.payload,
                lists: action.payload.lists,
            };
        case REMOVE_ERROR:
            return {
                ...state,
                payload: {},
            };
        default:
            return state;
    }
};
